<ng-container [ngSwitch]="EnvironmentService.type">
  <lib-match-widget
    *ngSwitchCase="EnvironmentType.widget"
    [eventId]="eventId"
    [teamId]="teamId">
  </lib-match-widget>

  <lib-match-web
    *ngSwitchCase="EnvironmentType.website"
    [eventId]="eventId"
    [teamId]="teamId">
  </lib-match-web>
</ng-container>
